/**
 * Ошибка динамического import() чанка react.lazy, который перестал
 * существовать по старому хэшированному имени -побочный эффект деплоя:
 */
const CHUNK_LOAD_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i, // Chrome/Vite
  /error loading dynamically imported module/i, // Firefox/Vite
  /importing a module script failed/i, // Safari
];

export const isChunkLoadError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return CHUNK_LOAD_ERROR_PATTERNS.some(re => re.test(message));
};
